var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Alert, Box, CircularProgress, IconButton, Paper, Stack, Typography } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { CloudinaryService } from "../services/cloudinary.service";
import { getScaledUrl, MediaSize } from "../utils/media.util";
import { Delete, PlayCircle, UploadFile } from "@mui/icons-material";
var PublicMediaUpload = function (_a) {
    var value = _a.value, onChange = _a.onChange, _b = _a.allowMultiple, allowMultiple = _b === void 0 ? false : _b, _c = _a.allowedTypes, allowedTypes = _c === void 0 ? ['image', 'video', 'file'] : _c;
    var theme = useTheme();
    var _d = useState(null), error = _d[0], setError = _d[1];
    var _e = useState(false), isUploading = _e[0], setIsUploading = _e[1];
    // Convert value to array for easier handling
    var mediaArray = Array.isArray(value) ? value : value ? [value] : [];
    // Convert CloudinaryResource to Media
    var convertToMedia = function (resource) {
        return {
            mediaURI: resource.secure_url,
            publicId: resource.public_id,
            provider: 'cloudinary',
            mediaFormat: resource.format
        };
    };
    // Get client allowed formats based on allowed types
    var getClientAllowedFormats = function () {
        var formats = [];
        if (allowedTypes.includes('image')) {
            formats.push('png', 'jpeg', 'jpg', 'gif', 'webp');
        }
        if (allowedTypes.includes('video')) {
            formats.push('mp4', 'mov', 'avi', 'webm');
        }
        if (allowedTypes.includes('file')) {
            formats.push('pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx');
        }
        return formats;
    };
    // Open Cloudinary widget for upload
    var handleUploadClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var hasImages, hasVideos, options, resources, medias, resource, media, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isUploading)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, 7, 8]);
                    setIsUploading(true);
                    setError(null);
                    hasImages = allowedTypes.includes('image');
                    hasVideos = allowedTypes.includes('video');
                    options = {
                        sources: ['local', 'url', 'camera'],
                        clientAllowedFormats: getClientAllowedFormats(),
                        maxFiles: allowMultiple ? 10 : 1,
                        folder: 'uploads',
                        resourceType: hasVideos && !hasImages ? 'video' : hasImages ? 'image' : 'auto',
                        maxFileSize: hasVideos ? 100 * 1024 * 1024 : 10 * 1024 * 1024, // 100MB for videos, 10MB for others
                    };
                    if (!allowMultiple) return [3 /*break*/, 3];
                    return [4 /*yield*/, CloudinaryService.uploadMultipleMedia('public-media-upload', options)];
                case 2:
                    resources = _a.sent();
                    medias = resources.map(convertToMedia);
                    onChange(__spreadArray(__spreadArray([], mediaArray, true), medias, true));
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, CloudinaryService.uploadMedia('public-media-upload', options)];
                case 4:
                    resource = _a.sent();
                    media = convertToMedia(resource);
                    onChange(media);
                    _a.label = 5;
                case 5: return [3 /*break*/, 8];
                case 6:
                    err_1 = _a.sent();
                    console.error('Upload error:', err_1);
                    setError(err_1 instanceof Error ? err_1.message : 'Failed to upload file');
                    return [3 /*break*/, 8];
                case 7:
                    setIsUploading(false);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var handleRemove = function (mediaToRemove) {
        var newMediaArray = mediaArray.filter(function (m) { return m.id !== mediaToRemove.id; });
        if (allowMultiple) {
            onChange(newMediaArray.length > 0 ? newMediaArray : undefined);
        }
        else {
            onChange(undefined);
        }
    };
    var renderMediaPreview = function (media) {
        var _a, _b;
        // Determine media type from format
        var imageFormats = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'svg'];
        var videoFormats = ['mp4', 'mov', 'avi', 'webm', 'mkv'];
        var format = ((_a = media.mediaFormat) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || '';
        var isImage = imageFormats.includes(format);
        var isVideo = videoFormats.includes(format);
        return (_jsxs(Paper, __assign({ sx: {
                position: 'relative',
                borderRadius: 1,
                overflow: 'hidden',
                border: '1px solid',
                borderColor: 'divider'
            } }, { children: [isImage ? (_jsx(Box, { component: "img", src: getScaledUrl(media, MediaSize.LARGE_600, MediaSize.LARGE_600), alt: "Uploaded image", sx: {
                        width: '100%',
                        height: 120,
                        objectFit: 'cover'
                    } })) : isVideo ? (_jsx(Box, __assign({ sx: {
                        width: '100%',
                        height: 120,
                        position: 'relative',
                        backgroundColor: 'grey.900'
                    } }, { children: media.publicId && media.provider === 'cloudinary' ? (_jsx(Box, { component: "video", src: media.mediaURI, controls: true, sx: {
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain'
                        } })) : (_jsx(Box, __assign({ sx: {
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        } }, { children: _jsx(PlayCircle, { sx: {
                                color: theme.palette.grey[400]
                            } }) }))) }))) : (_jsxs(Box, __assign({ sx: {
                        height: 120,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: 'grey.100'
                    } }, { children: [_jsx(Paper, { sx: {
                                color: theme.palette.text.secondary
                            } }), _jsx(Typography, __assign({ variant: "caption", sx: { mt: 1, px: 1, textAlign: 'center' } }, { children: ((_b = media.publicId) === null || _b === void 0 ? void 0 : _b.split('/').pop()) || 'Document' }))] }))), _jsx(IconButton, __assign({ size: "small", onClick: function () { return handleRemove(media); }, sx: {
                        position: 'absolute',
                        top: 4,
                        right: 4,
                        backgroundColor: alpha(theme.palette.error.main, 0.9),
                        color: 'white',
                        '&:hover': {
                            backgroundColor: theme.palette.error.dark
                        }
                    } }, { children: _jsx(Delete, {}) })), (isImage || isVideo) && media.publicId && (_jsx(Typography, __assign({ variant: "caption", sx: {
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        backgroundColor: alpha(theme.palette.common.black, 0.6),
                        color: 'white',
                        px: 1,
                        py: 0.5,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                    } }, { children: media.publicId.split('/').pop() })))] }), media.id));
    };
    return (_jsxs(Stack, __assign({ spacing: 2 }, { children: [(!value || allowMultiple) && (_jsx(Paper, __assign({ sx: {
                    p: 2,
                    border: "2px dashed ".concat(theme.palette.divider),
                    borderRadius: 2,
                    backgroundColor: 'transparent',
                    cursor: isUploading ? 'not-allowed' : 'pointer',
                    transition: 'all 0.2s ease',
                    opacity: isUploading ? 0.6 : 1,
                    '&:hover': {
                        borderColor: isUploading ? theme.palette.divider : theme.palette.primary.main,
                        backgroundColor: isUploading ? 'transparent' : alpha(theme.palette.primary.main, 0.02)
                    }
                }, onClick: handleUploadClick }, { children: _jsxs(Stack, __assign({ alignItems: "center", spacing: 1.5 }, { children: [_jsx(Box, __assign({ sx: {
                                width: 56,
                                height: 56,
                                borderRadius: '50%',
                                backgroundColor: alpha(theme.palette.primary.main, 0.1),
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            } }, { children: isUploading ? (_jsx(CircularProgress, { size: 40, sx: { color: theme.palette.primary.main } })) : (_jsx(UploadFile, { sx: {
                                    color: theme.palette.primary.main
                                } })) })), _jsxs(Box, __assign({ textAlign: "center" }, { children: [_jsx(Typography, __assign({ variant: "body1", fontWeight: 500 }, { children: isUploading
                                        ? 'Uploading...'
                                        : 'Click to upload' })), !isUploading && (_jsxs(_Fragment, { children: [_jsx(Typography, __assign({ variant: "caption", color: "text.secondary" }, { children: allowMultiple ? 'You can upload multiple files' : 'Upload a single file' })), _jsx(Typography, __assign({ variant: "caption", color: "text.secondary", display: "block", sx: { mt: 0.5 } }, { children: "Max size: 10MB for images/documents, 100MB for videos" }))] }))] }))] })) }))), mediaArray.length > 0 && (_jsx(Box, __assign({ sx: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
                    gap: 2
                } }, { children: mediaArray.map(function (media) { return renderMediaPreview(media); }) }))), error && (_jsx(Alert, __assign({ severity: "error", onClose: function () { return setError(null); } }, { children: error })))] })));
};
export default PublicMediaUpload;
